// Response shapes for the bookmarks routes. All envelopes use a single
// top-level key so the SPA can dispatch on the URL alone.
import { z } from 'zod';
import { Bookmark, BookmarkCollection, BookmarkLocation, } from './collection.js';
export const CollectionResponse = z.object({ collection: BookmarkCollection });
export const CollectionListResponse = z.object({
    collections: z.array(BookmarkCollection),
    total: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
});
/** Returned by the read endpoint of a single collection — collection
 *  metadata + paged bookmarks. */
export const CollectionWithItemsResponse = z.object({
    collection: BookmarkCollection,
    bookmarks: z.array(Bookmark),
    total: z.number().int().nonnegative(),
    limit: z.number().int().nonnegative(),
    offset: z.number().int().nonnegative(),
});
export const BookmarkResponse = z.object({ bookmark: Bookmark });
export const BookmarkLocationsResponse = z.object({
    locations: z.array(BookmarkLocation),
});
export const BookmarkLocationsBatchResponse = z.object({
    locationsByArticleId: z.record(z.string().uuid(), z.array(BookmarkLocation)),
});
//# sourceMappingURL=responses.js.map